// ** Custom Filters
import { compute as filterSexCompute } from "hooks/filters/useFilterSexSeo";
import { compute as filterPreferencesCompute } from "hooks/filters/useFilterPreferencesSeo";

// #####################################################

const useUsersSeoApiParams = ({
	countryUrl,
	regionUrl,
	cityUrl,
	filterUrl,
}) => {
	const sex = filterSexCompute(false).urlToApiParam(filterUrl);

	const isSexFilterValid = sex > 0;

	const preferences = filterPreferencesCompute.urlToApiParam(filterUrl);
	const isPreferencesFilterValid =
		Number.isInteger(preferences) && preferences > 0;

	const getApiParams = () => {
		return {
			sort: "special2",
			page: 1,
			sex: isSexFilterValid ? sex : null,
			sex_couple_1: null,
			sex_couple_2: null,
			age_min: null,
			age_max: null,
			country: countryUrl,
			region: regionUrl,
			city: cityUrl,
			distance: null,
			only: null,
			s_sex: null,
			s_age: null,
			s_for: null,
			language: null,
			height_min: null,
			height_max: null,
			figure: null,
			zodiac: null,
			hair: null,
			relationship: null,
			kids: null,
			drinking: null,
			smoking: null,
			education: null,
			preference: isPreferencesFilterValid ? preferences : null,
			name: null,
			view: "list",
			limit: 20,
		};
	};

	// #####################################################

	return { getApiParams };
};

// #####################################################

export default useUsersSeoApiParams;

// #####################################################
